import { createAction } from 'redux-actions';
import { history, store } from 'store';
import Types from './types';

export const authenticateRequest = createAction(Types.AUTHENTICATE_REQUEST);
export const authenticateFulfilled = createAction(Types.AUTHENTICATE_FULFILLED);
export const authenticateRejected = createAction(Types.AUTHENTICATE_REJECTED);

export const authCheckRestrictionsRequest = createAction(
  Types.AUTH_CHECK_RESTRICTIONS_REQUEST
);
export const authCheckRestrictionsFulfilled = createAction(
  Types.AUTH_CHECK_RESTRICTIONS_FULFILLED
);
export const authCheckRestrictionsRejected = createAction(
  Types.AUTH_CHECK_RESTRICTIONS_REJECTED
);

export const authenticateInvalidateSession = createAction(
  Types.AUTHENTICATE_INVALIDATE_SESSION
);

export const authenticateMFARequest = createAction(
  Types.AUTHENTICATE_MFA_REQUEST
);
export const authenticateMFAFulfilled = createAction(
  Types.AUTHENTICATE_MFA_FULFILLED
);
export const authenticateMFARejected = createAction(
  Types.AUTHENTICATE_MFA_REJECTED
);

export const mfaChangeRegionFulfilled = createAction(
  Types.MFA_CHANGE_REGION_FULFILLED
);

export const forgotPasswordRequest = createAction(
  Types.FORGOT_PASSWORD_REQUEST
);
export const forgotPasswordRequestFulfilled = createAction(
  Types.FORGOT_PASSWORD_FULFILLED
);
export const forgotPasswordRequestRejected = createAction(
  Types.FORGOT_PASSWORD_REJECTED
);

export const registerPasswordRequest = createAction(
  Types.REGISTER_PASSWORD_REQUEST
);
export const registerPasswordFulfilled = createAction(
  Types.REGISTER_PASSWORD_FULFILLED
);
export const registerPasswordRejected = createAction(
  Types.REGISTER_PASSWORD_REJECTED
);

export const selectCompany = createAction(Types.SELECT_COMPANY);
export const selectPartner = createAction(Types.SELECT_PARTNER);

export const trustedLoginRequest = createAction(Types.TRUSTED_LOGIN_REQUEST);
export const trustedLoginFulfilled = createAction(
  Types.TRUSTED_LOGIN_FULFILLED
);
export const trustedLoginRejected = createAction(Types.TRUSTED_LOGIN_REJECTED);

export const authenticateLogout = () => {
  store.dispatch({ type: 'CLEAR_STORE' });
  history.push('/');

  return {
    type: Types.AUTHENTICATE_LOGOUT,
  };
};
